import "core-js/modules/es.array.push.js";
import router from '@/router';
export const useRouterHelperStore = defineStore('routerHelper', {
  state: () => ({
    editStatus: {}
  }),
  actions: {
    setEditStatus(listRouteName, route) {
      this.editStatus[listRouteName] = {
        isEditing: true,
        route
      };
    },
    clearEditStatus(listRouteName) {
      delete this.editStatus[listRouteName];
    },
    getEditStatus(listRouteName) {
      return this.editStatus[listRouteName] || {
        isEditing: false
      };
    },
    push(routeName, query) {
      const route = router.currentRoute.value; // ← 合法获取当前路由
      const editRoute = {
        name: routeName,
        query
      };
      this.setEditStatus(route.name, editRoute);
      router.push(editRoute);
    },
    checkRefresh(searchFn) {
      const route = router.currentRoute.value;
      if (route.query.refresh) {
        searchFn();
        router.replace({
          query: {}
        });
      }
    },
    back(routeName) {
      const route = router.currentRoute.value;
      const listRouteName = routeName ?? route.meta.listRouteName;
      this.clearEditStatus(listRouteName);
      router.replace({
        name: listRouteName
      });
    },
    saveBack(routeName) {
      const route = router.currentRoute.value;
      const listRouteName = routeName ?? route.meta.listRouteName;
      this.clearEditStatus(listRouteName);
      router.replace({
        name: listRouteName,
        query: {
          refresh: Date.now()
        }
      });
    },
    handleBeforeLeave(to, next) {
      const route = router.currentRoute.value;
      const listRouteName = route.meta.listRouteName;
      if (to.name === listRouteName) {
        this.clearEditStatus(listRouteName);
      }
      next();
    }
  }
});